/**
 * "Email me the editable version" on the /free/* template pages
 * (conversion programme CONV-CP-4, built switched OFF).
 *
 * The downloads stay free with no form. This optional box emails the Word
 * file's link to the address typed in, and — only when the visitor ticks the
 * separate box — asks them to confirm occasional tips, through the same
 * double-opt-in confirmation the /demo capture uses.
 *
 * Kept data-only so the client form can import the copy and the flag key.
 */

/**
 * DB feature flag (lib/feature-flags.ts, /admin/feature-flags). Absent or
 * disabled = OFF: no form renders and the API answers 404. Turn it on (100%)
 * only once the wording below has been approved.
 */
export const FREE_TEMPLATE_EMAIL_FLAG_KEY = "free_template_email_capture";

/** DemoLead.source for leads captured by this box. */
export const FREE_TEMPLATE_EMAIL_LEAD_SOURCE = "free_template";

export const FREE_TEMPLATE_EMAIL_COPY = {
  heading: "Email me the editable version",
  description:
    "We'll send the Word file to your inbox so you can fill it in later.",
  emailLabel: "Your email address",
  marketingLabel:
    "Also send me occasional tips on CDM paperwork. We'll ask you to confirm first.",
  privacy:
    "We use your address to send this template. We only send tips if you tick the box and confirm. Unsubscribe any time.",
  submit: "Email it to me",
  sending: "Sending…",
  sent:
    "Sent. Check your inbox, and your spam folder if it isn't there.",
  invalidEmail: "Please enter a valid email address.",
  failed: "Something went wrong. Please try again, or download the file above.",
  rateLimited: "Too many requests. Please try again later, or download the file above.",
} as const;
